<template>
  <modal :modal-key="'bundle-discount'"
         :class-style="'modal--welcomeback modal--zero-balance'" :body-style="'welcome-pad'"
         :header-style="'daily_bonus'"
         @close="$emit('close')">
    <template slot="header">
      <h1>{{ getTranslations.home_daily_bonus_daily }}</h1>
      <img class="pinicon" src="static/images/daily_bonus_icon.svg" alt="">
    </template>
    <template slot="body">
      <h2 class="modal_sub">{{ getTranslations.home_daily_bonus_header }}</h2>
      <p>{{ getTranslations.home_daily_bonus_desc }}</p>
      <div class="daily_bonus_calendar">
        <bonus-daily-days v-for="index in 7"
                          :key="index"
                          :index="index">
        </bonus-daily-days>
      </div>
    </template>
  </modal>
</template>

<script>
// modal_daily_bonus_calendar_step_1.html
import { mapGetters, mapMutations, mapState } from 'vuex';
import Modal from '@/components/home/modals/shared/GenericModal';
import BonusDailyDays from './BonusDailyDays';
import GameBonus from './daily_bonus_modals/GameBonus';
import PointsBonus from './daily_bonus_modals/PointsBonus';
import DailyBonusSpinningWheel from './daily_bonus_modals/DailyBonusSpinningWheel';

export default {
  name: 'bonus-daily',
  data() {
    return {
      timer: 0,
      counter: 0,
    };
  },
  components: {
    BonusDailyDays,
    Modal,
  },
  created() {
    setTimeout(() => {
      // after 5 secs show modal
      let modal;
      switch (this.bonusDailyModal.dailyBonusType) {
      case 'GAMES':
        modal = GameBonus;
        break;
      case 'POINTS':
        modal = PointsBonus;
        break;
      case 'SPIN_WHEEL':
        modal = DailyBonusSpinningWheel;
        break;
      default:
        modal = null;
        break;
      }
      this.storeModalForHomePage(modal);
    }, 5000);
  },
  methods: {
    ...mapMutations('common', [
      'storeModalForHomePage',
    ]),
  },
  computed: {
    ...mapGetters('i18n', [
      'getTranslations',
    ]),
    ...mapState('profile', [
      'bonusDailyModal',
    ]),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/home/modals/bonus_phases/BonusDaily.vue